export default class ExpandableTable {
    constructor() {
        this.tables = document.querySelectorAll('.js-expandable-table-rows');
        if (!this.tables.length) return;

        this.init();
    }

    init() {
        this.tables.forEach(table => {
            table.addEventListener('click', (e) => {
                const trigger = e.target.closest('.js-expand-link');
                if (!trigger) return;

                // Only prevent default for the expand link itself
                e.preventDefault();

                const tableRow = trigger.closest('tr.js-expand-trigger');
                if (!tableRow) return;

                this.toggleRow(table, tableRow, trigger);
            });
        });

        // Also allow close buttons inside expanded content
        this.tables.forEach(table => {
            table.querySelectorAll('.close-details-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const contentRow = e.target.closest('tr.js-expand-content');
                    if (!contentRow) return;
                    const id = contentRow.dataset.expandContent;
                    const tableRow = table.querySelector(`.js-expand-trigger[data-expand="${id}"]`);
                    const link = tableRow.querySelector('.js-expand-link');
                    this.closeRow(contentRow, link);
                });
            });
        });
    }

    toggleRow(table, row, link) {
        const id = row.dataset.expand;
        if (!id) return;

        const contentRow = table.querySelector(`[data-expand-content="${id}"]`);
        if (!contentRow) return;

        const isOpen = contentRow.classList.contains('is-open');

        // Close all rows in this table
        table.querySelectorAll('.js-expand-content').forEach(r => {
            r.classList.remove('is-open');
            r.style.display = 'none';
        });
        table.querySelectorAll('.js-expand-link').forEach(l => l.classList.remove('is-open'));
        table.querySelectorAll('.js-expand-link').forEach(l => l.setAttribute('aria-expanded', 'false'));

        if (!isOpen) {
            contentRow.classList.add('is-open');
            contentRow.style.display = 'table-row';
            link.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
        } else {
            contentRow.classList.remove('is-open');
            contentRow.style.display = 'none';
            link.classList.remove('is-open');
            link.setAttribute('aria-expanded', 'false');
        }
    }

    closeRow(contentRow, link) {
        contentRow.classList.remove('is-open');
        contentRow.style.display = 'none';
        if (link) {
            link.classList.remove('is-open');
            link.setAttribute('aria-expanded', 'false');
        }
    }
}